module.exports = __webpack_public_path__ + "static/media/court.b1e28d02.svg";